export const METRICS_COLUMNS_SPACER_WIDTH = 20;
export const MACHINE_BREAKDOWN_METRIC_WIDTH = 75;
export const MACHINE_BREAKDOWN_PROCESS_NAME_LINK_WIDTH = 100;
